import React from 'react';
import styles from './FilterRow.module.css';

let _mvId = 0;

// Chip-style multi-value input. `options` (when given) backs a datalist
// suggestion list. Extracted out of FilterRow so PropertyFilters (event
// properties' "in"/"not in" operator) gets the exact same widget instead of
// a second implementation — same reasoning PropertyFilters.jsx itself was
// already extracted from FilterRow for.
export default function MultiValueInput({ options, value, onChange, placeholder }) {
  const [text, setText] = React.useState('');
  const listId = React.useRef('mv-' + (++_mvId)).current;

  function commit(raw) {
    const v = raw.trim();
    if (!v || value.includes(v)) { setText(''); return; }
    onChange([...value, v]);
    setText('');
  }

  return (
    <div className={styles.multiWrap}>
      {value.map((v) => (
        <span key={v} className={styles.chip}>
          {v}
          <button type="button" className={styles.chipRemove} onClick={() => onChange(value.filter((x) => x !== v))}>×</button>
        </span>
      ))}
      <input
        className={styles.multiInput}
        list={options ? listId : undefined}
        value={text}
        placeholder={value.length ? '' : (placeholder || 'Add value…')}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); commit(text); }
          else if (e.key === 'Backspace' && !text && value.length) onChange(value.slice(0, -1));
        }}
        onBlur={() => commit(text)}
      />
      {options && (
        <datalist id={listId}>
          {options.filter((o) => !value.includes(o)).map((o) => <option key={o} value={o} />)}
        </datalist>
      )}
    </div>
  );
}
